
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_2","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 32 32","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M1 25.3h30c.4 0 .8-.3.8-.8s-.3-.8-.8-.8h-1.8V5.1c0-.9-.7-1.6-1.6-1.6h-2.2c-.9 0-1.6.7-1.6 1.6v18.7h-1.6V11.5c0-.9-.7-1.6-1.6-1.6h-2.2c-.9 0-1.6.7-1.6 1.6v12.3h-1.6V9.3c0-.9-.7-1.6-1.6-1.6h-2.2c-.9 0-1.6.7-1.6 1.6v14.4H8.4V13.1c0-.9-.7-1.6-1.6-1.6H4.7c-.9 0-1.6.7-1.6 1.6v10.7H1c-.4 0-.8.3-.8.8s.4.7.8.7zM31 26.8H1c-.4 0-.8.3-.8.8s.3.8.8.8h30c.4 0 .8-.3.8-.8s-.4-.8-.8-.8z"}})])
          )
        }
      }
    